import { Accordion, AccordionDetails, List, Box, Card, CardContent, CardHeader, LinearProgress, Typography, Unstable_Grid2 as Grid, Paper, IconButton, ListItemButton, ListItemIcon, Icon, TextField, Switch, FormControlLabel, Select, MenuItem, AccordionSummary, ListItem, ListItemText, InputAdornment, Button, Checkbox } from "@mui/material";
import { CheckBox, Clear, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { BuildJobInfo, JobType } from "../../../data/interfaces/jobmodels";
import Jobs from "../jobsmain";
import BuildJob from "./buildjob";
import jobService from "../../../data/api/job.service";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";
import { JobTask } from "../../../data/interfaces/tablegenmodels";


export default function BuildStatus() {
    const [buildjobs, setBuildJobs] = useState<BuildJobInfo[]>([]);
    const [selectedJob, setSelectedJob] = useState<BuildJobInfo | null>(null);
    const [periods, setPeriods] = useState<DropdownModel[]>([]);
    const [statuses, setStatuses] = useState<DropdownModel[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<string | null>("-99");
    const [selectedPeriod, setSelectedPeriod] = useState<string>("1");
    const [tasks, setTasks] = useState<JobTask[]>([]);
    const [includeReleased, setIncludeReleased] = useState<boolean>(false);
    const [onlyMyjobs, setOnlyMyjobs] = useState<boolean>(false);
    const [jobNumber, setJobNumber] = useState<string | null>(null);
    const [needRefresh,setNeedRefresh]=useState<boolean>(false);
    const [autoRefresh,setAutoRefresh]=useState<boolean>(false);
    var refreshId: number | NodeJS.Timeout | string | undefined;
    useEffect(() => {
        jobService.getJobStatuses().then((response) => {
            setStatuses(response.data);
        });
        jobService.getFilterTimePeriods().then((response) => {
            setPeriods(response.data);
        });

    }, []);

    useEffect(() => {
        if (periods.length > 0) {
            setSelectedPeriod(periods[0].Id);
        }
    }, [periods])

    useEffect(() => {

        updateJobs();

    }, [selectedStatus, selectedPeriod, includeReleased, jobNumber,onlyMyjobs]);

    useEffect(()=>{
        if(!needRefresh||!autoRefresh){
            if(!refreshId)clearInterval(refreshId);
            return;
        }
        refreshId = setInterval(updateStatus, 5000);
        return () => clearInterval(refreshId);
    },[needRefresh,autoRefresh]);
    const updateStatus=()=>{
        updateJobs();
    }

    useEffect(() => {
        // if (buildjobs.length > 0 && (selectedJob == undefined||needRefresh)) {
        //     setSelectedJob(buildjobs[0]);
        // }
        //setNeedRefresh(false);
        setNeedRefresh(buildjobs.findIndex(a=>a.Progress<100)>-1);
        
    }, [buildjobs]);

    useEffect(() => {
        if (selectedJob && tasks.findIndex(a => a.JobId == selectedJob.Id) < 0) {
            refreshTasks();
        }
    }, [selectedJob]);

    const refreshTasks=()=>{
        if(needRefresh){
            jobService.getTasksBg(selectedJob?.Id ?? 0).then((reponse) => {
                let tempTasks = [];
                if (reponse.data) {
                    for (var i = 0; i < reponse.data.length; i++) {
                        var task = reponse.data[i];
                        if (tempTasks.findIndex(a => a.Id == task.Id) < 0)
                            tempTasks.push(task);
                    }
    
                    setTasks(tempTasks);
                }
            });
        }
        else{
        jobService.getTasks(selectedJob?.Id ?? 0).then((reponse) => {
            let tempTasks = [];
            if (reponse.data) {
                for (var i = 0; i < reponse.data.length; i++) {
                    var task = reponse.data[i];
                    if (tempTasks.findIndex(a => a.Id == task.Id) < 0)
                        tempTasks.push(task);
                }

                setTasks(tempTasks);
            }
        });
    }

        
    }

    const updateJobs = () => {
        if(needRefresh){
            if (selectedPeriod && selectedStatus) {
                jobService.getJobsBg(includeReleased, JobType.Build, selectedPeriod, selectedStatus, jobNumber,onlyMyjobs).then((response) => {
                    setBuildJobs(response.data);
                });
            }
        }
        else{
        if (selectedPeriod && selectedStatus) {
            jobService.getJobs(includeReleased, JobType.Build, selectedPeriod, selectedStatus, jobNumber,onlyMyjobs).then((response) => {
                setBuildJobs(response.data);
            });
        }
    }
    }

    const handleShowLogs=(job: BuildJobInfo)=> {
        if(job.Id==selectedJob?.Id)
            setSelectedJob(null);
        else
            setSelectedJob(job);

    }


    const handleListItemClick = (
        event: React.SyntheticEvent,
        expanded: boolean,
        job: BuildJobInfo,
    ) => {
        if (expanded&&selectedJob?.Id != job.Id)
            setSelectedJob(job);
        else
            setSelectedJob(null);
    };

    const refresh = () => {
        updateJobs();
        //refreshTasks();
    }

    const BuildStatusHeader = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{display:'flex'}}>
                <Typography variant="h6">Build Jobs</Typography>
                <FormControlLabel sx={{color:'black',mt:-.5,ml:2}} label="Auto Refresh" control={<Checkbox  checked={autoRefresh} onChange={(e,checked)=>{setAutoRefresh(checked);}} />}/>
                </Box>
                <Button variant="outlined" onClick={refresh}>Refresh</Button>
            </Box>
        )
    }
    return (
        <Grid container spacing={1}>
            <Grid xs={selectedJob? 6:12}>
                <Card>
                    <CardHeader title={<BuildStatusHeader />} sx={{ color: "primary.main" }} />
                    <CardContent>
                        <Grid container spacing={2} sx={{ mb: 1 }}>
                            <Grid xs={4}>
                                <TextField onChange={(event) => { setJobNumber(event.target.value) }} placeholder="Search Job Number" size="small" sx={{ width: '100%' }} />
                            </Grid>
                            <Grid xs={4}>
                                <FormControlLabel labelPlacement="start" control={<Switch value={includeReleased} onChange={(event, value) => { setIncludeReleased(value) }} />} label="Include Released" sx={{ width: '100%' }} />
                            </Grid>
                            <Grid xs={4}>
                                <FormControlLabel labelPlacement="start" control={<Switch value={onlyMyjobs} onChange={(event, value) => { setOnlyMyjobs(value) }} />} label="My Jobs" sx={{ width: '100%' }} />
                            </Grid>
                            <Grid xs={6}  >
                                <Select label='Select Time Period' sx={{ width: '100%' }} size="small" value={selectedPeriod} 
                                    onChange={(event) => { setSelectedPeriod(event.target.value? event.target.value.toString():"1") }}
                                    >
                                    {
                                        periods.map((period) => {
                                            return (
                                                <MenuItem key={period.Id} value={period.Id} >{period.Description}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Grid>
                            <Grid xs={6}>
                                <Select label='Select Status' sx={{ width: '100%' }} size="small" value={selectedStatus}
                                    onChange={(event) => { setSelectedStatus(event.target.value) }}>
                                    <MenuItem key={-99} value={-99} >All</MenuItem>
                                    {
                                        statuses.map((status) => {
                                            return (
                                                <MenuItem key={status.Id} value={status.Id} >{status.Description}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Grid>
                        </Grid>
                        <List>
                            {buildjobs.map((job) => {
                                                                return (
                                    <Accordion key={job.Id} expanded={selectedJob?.Id==job.Id}  >
                                        <AccordionSummary
                                            aria-controls={job.JobNumber + "-content"}
                                            id={job.JobNumber + "-header"}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    //width:'10px',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}>
                                                <Icon>{job.TicketType == 'Magnetic' ? 'credit_card' : 'train'}</Icon>
                                            </ListItemIcon>
                                            <Box sx={{ display: 'inline-grid', width: '35%', flexShrink: 0 }}>
                                                <Typography sx={{ fontWeight: 'bold' }}>
                                                    {job.JobNumber}
                                                </Typography>
                                                <Typography >
                                                {job.CreatedDate}
                                                
                                                    
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'inline-grid', width: '65%' }}>
                                                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                                                
                                                <Typography variant="body1" textOverflow="ellipsis">{job.Description}</Typography>
                                                </Box>
                                                
                                                <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
                                                <Typography sx={{ color: 'text.secondary' }}>{job.Status}</Typography>
                                                    <Box sx={{  width: '100%', mr: 1,ml:1 }}>
                                                        <LinearProgress variant="determinate" value={job.Progress} valueBuffer={100} />
                                                        
                                                    </Box>
                                                    
                                                    <Box sx={{ minWidth: 35 }}>
                                                        <Typography variant="body2" color="text.secondary">{`${Math.round(
                                                            job.Progress,
                                                        )}%`}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Button sx={{ml:1}} variant="outlined" disabled={job.Progress!=100} onClick={()=>handleShowLogs(job)}>{job.Id==selectedJob?.Id?'Hide Details':'Show Details'} </Button>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List>
                                                {tasks.filter(j => j.JobId == job.Id).map((task) => {
                                                    return (
                                                        <ListItem key={task.Id} component={Paper}>
                                                            <ListItemText>{task.Nlc ?? "Global"}</ListItemText>
                                                            <ListItemText>{task.Table}</ListItemText>
                                                            <ListItemText>{task.Status}</ListItemText>
                                                        </ListItem>
                                                    )
                                                })

                                                }
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                )
                            })

                            }
                        </List>
                    </CardContent>
                </Card>
            </Grid>
            {selectedJob?
            <Grid xs={6}>
                <BuildJob job={selectedJob} needRefresh={needRefresh} />
            </Grid>:null}
        </Grid>
    )
}